import { isEmpty } from 'lodash-es';
import { useRoutes, useLocation } from 'react-router-dom';

import { useUserContext } from '../context';
import { getAuthToken } from '../utils/token';

import { publicRoutes } from './public';
import RouteChecker from './RouteChecker';

const Routes = () => {
  const user = useUserContext();
  const element = useRoutes([...publicRoutes]);
  const location = useLocation();
  if (location.search.includes('corphiringTemplate=')) {
    sessionStorage.setItem('sessionCandidateProfileRedirectUrlCorpHiring', window.location.href);
  }

  return (
    <>
      {!isEmpty(getAuthToken()) &&
      user &&
      !location.pathname.includes('/data-protection') &&
      !location.pathname.includes('/subscription') &&
      !location.pathname.includes('/unsubscribe') &&
      !location.pathname.includes('/subscribed') ? (
        <RouteChecker />
      ) : (
        element
      )}
    </>
  );
};

export default Routes;
